<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h4 style="margin-top: 10px">Confirm</h4>
            <button
              type="button"
              class="btn btn-danger btn-sm"
              style="margin: 0"
              @click="$emit('close')"
            >
              X
            </button>
          </div>

          <div class="modal-body">
            <p>
              Confirm code sent to your email {{ email }}. Please get and fill
              it to below:
            </p>
            <label for="confirmCode"><strong>Confirm code</strong></label>
            <input
              id="confirmCode"
              ref="first"
              placeholder="Enter confirm code"
              type="text"
              v-model="code"
              class="form-control mt-2"
            />
            <p class="small">
              If you can not received confirm code. Please wait for a while and
              press <strong>Resend code</strong> button.
            </p>
          </div>

          <div class="modal-footer">
            <button
              style="margin-right: 10px"
              :disabled="!isResend"
              type="button"
              class="btn btn-sm btn-warning"
              @click="resend"
            >
              {{ message }}
            </button>
            <button
              style="margin-right: 10px"
              type="button"
              class="modal-default-button btn btn-sm btn-primary"
              @click="confirm"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
var timeValue = 5 * 60;
export default {
  name: "ConfirmCodeModal",
  props: {
    email: String,
  },
  data() {
    return {
      code: "",
      timerCount: timeValue,
      isResend: false,
      message: "",
    };
  },
  mounted() {
    this.message = `Resend code (${timeValue})`;
    this.$refs.first.focus();
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
            this.message = `Resend code (${this.timerCount})`;
          }, 1000);
        } else {
          this.isResend = true;
          this.message = `Resend code`;
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  methods: {
    async resend() {
      this.timerCount = timeValue;
      this.isResend = false;
      this.$refs.first.focus();
      if (this.code !== "") {
        const resp = await this.$http
          .post("/api/auth/resend", {
            email: this.email,
            code: this.code,
          })
          .catch((err) => {
            this.$swal({
              icon: "error",
              text: err,
            });
          });

        if (resp.data.status === "Error") {
          this.$emit("close");
          this.$swal({
            icon: "error",
            text: "Resend Fail",
          });
        } else {
          localStorage.userAccount = JSON.stringify({
            email: this.email,
            code: this.code,
          });
        }
      }
    },
    async confirm() {
      if (this.code !== "") {
        const resp = await this.$http
          .post("/api/auth/confirm", {
            email: this.email,
            code: this.code,
          })
          .catch((err) => {
            this.$swal({
              icon: "error",
              text: err,
            });
          });

        if (
          resp.data.status === "Error" &&
          resp.data.message == "ConfirmCodeExpiried"
        ) {
          this.$emit("close");
          this.$swal({
            icon: "error",
            text: "Confirm code expired",
          });
        } else {
          localStorage.userAccount = JSON.stringify({
            email: this.email,
            code: this.code,
          });
          // window.location = "/reset-password";
          this.$router.push({ name: "ResetPassword" });
        }
      }
    },
  },
};
</script>

<style scoped>
.modal-header {
  padding-top: 10px !important;
  padding-bottom: 7px;
}
.modal-header h3 {
  margin-top: 0;
  padding: 0;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 400px;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-body {
  margin-bottom: 10px;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>